import "../css/style.css"
import Navbar from "../components/navbar"
import { useState } from "react"
import { FaBars } from "react-icons/fa"
import { Select, Space } from "antd"
import { locations } from "../components/locations"
import { AiFillInfoCircle } from "react-icons/ai"
import Footer from "../components/footer"
import { Tag } from "antd"

const MyJobsPage = () => {
    const [navShown, setNavShown] = useState("hidden")
    const [showBar, setShowBar] = useState(true)
    const [showXmark, setShowXmark] = useState("hidden")
    const [specialityOptions, setSpecialityOptions] = useState(["Accute Care Float", "Trauma ICU", "Urgent Care", "Utilization Review", "Vaccination Review", "Wound Care", "Transplant"])
    const [specialitySelected, setSpecialitySelected] = useState(specialityOptions[0])
    const [selectedLocation, setSelectedLocation] = useState(locations[0])
    const openNav = () => {
        setNavShown("block")
        setShowBar("hidden")
        setShowXmark("inline")
    }
    const closeNav = () => {
        setNavShown("hidden")
        setShowBar("inline")
        setShowXmark("hidden")
    }

    const { Option } = Select;

    const handleChange = (value) => {
        console.log(`selected ${value}`);
        setSpecialitySelected(value)
    };

    let relatedSpecialitiesArray = ["one", "two", "three", "four", "five", "six", "seven"]


    return (
        <Navbar active={"jobs"} navShow={navShown}>
            <div>
                {/* Sidebar div starts */}
                <div className="flex w-full bg-cyan-900 items-center fixed z-20">
                    <FaBars className={`text-[20px] text-white relative left-4 lg:hidden ${showBar}`} onClick={openNav} />
                    <span className={`text-[25px] ${showXmark} text-white font-bold relative left-72`} onClick={closeNav}>
                        X
                    </span>
                    <h1 className="text-center text-white py-4 w-full font-bold">My Jobs</h1>
                </div>
                {/* Sidebar div ends  */}

                <div className="w-[90%] lg:w-[95%] m-auto pb-2">
                    <div className="rounded-xl p-3 relative top-16" style={{
                        boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px",
                    }}>
                        <h1 className="font-semibold text-lg">Recommended by Your Recruiter (0)</h1>
                        <p className="pt-2 text-sm"> When your recruiter finds job recommendations for you, they'll show up here.</p>
                    </div>
                    <div className="rounded-xl p-4 mt-20" style={{
                        boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px",
                    }}>
                        <h1 className="font-semibold text-lg">Your next adventure's just a search away!</h1>
                        <div className="mt-2">
                            <label htmlFor="speciality-select" className="font-semibold my-2 text-sm">Your Speciality</label>
                            <Select
                                id="speciality-select"
                                mode="multiple"
                                style={{
                                    width: '100%',
                                }}
                                placeholder="Specialities"
                                defaultValue={specialityOptions[0]}
                                onChange={handleChange}
                                optionLabelProp="label"
                            >
                                {
                                    specialityOptions?.map((val, i) => {
                                        return (
                                            <Option key={i} value={val} label={val}>
                                                <Space>
                                                    {val}
                                                </Space>
                                            </Option>
                                        )
                                    })
                                }
                            </Select>

                            {relatedSpecialitiesArray?.length > 0 && <div>
                                <span className="block font-semibold my-2 text-sm">Related Specialities</span>
                                <div>
                                    {
                                        relatedSpecialitiesArray?.map((val, i) => {
                                            return (
                                                <Tag className="" key={i} closable onClose={(e) => console.log(e)}>{val}</Tag>
                                            )
                                        })
                                    }
                                </div>
                            </div>}

                        </div>
                        {/* Locations Content  */}
                        <div className="mt-4 lg:mt-6">
                            <label htmlFor="location-select" className="font-semibold text-sm">Location</label>
                            <Select
                                id="location-select"
                                mode="multiple"
                                style={{
                                    width: '100%',
                                }}
                                placeholder="Locations"
                                defaultValue={selectedLocation}
                                onChange={(val) => {
                                    setSelectedLocation(val)
                                }}
                                optionLabelProp="label"
                            >
                                {
                                    locations?.map((val, i) => {
                                        return (
                                            <Option key={i} value={val} label={val}>
                                                <Space>
                                                    {val}
                                                </Space>
                                            </Option>
                                        )
                                    })
                                }
                            </Select>
                        </div>
                        <div className="bg-[#eceff1] p-4 lg:mt-10 mt-2">
                            <div className="flex items-center gap-2">
                                <input type="radio" name="license" id="" />
                                <p>Compact license state</p>
                            </div>
                            <div className="flex items-center gap-2">
                                <input type="radio" name="license" id="" />
                                <p>Quick license state</p>
                            </div>
                            <div className="flex my-3 items-start" >
                                <AiFillInfoCircle className="pr-2 text-[30px]" />
                                <p className="w-[300px] sm:w-[480px] text-sm">
                                    Many jobs don’t require a license in hand to apply. Your recruiter can
                                    help plan for your ideal locations. We'll get you licensed quickly!
                                </p>
                            </div>
                        </div>
                        <button className="bg-[#47D0E6] uppercase px-4 py-1 mt-4 rounded-full font-semibold">
                            Search Jobs
                        </button>
                    </div>

                    <div className="rounded-xl p-3 relative top-10" style={{
                        boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px",
                    }}>
                        <div className="flex-col lg:flex-row flex justify-between items-center">
                            <div className="md:w-1/2">
                                <span className="font-bold">
                                    Get notified of bucket list places in real time with saved searches...
                                </span>
                            </div>
                            <div className="md:w-1/2">
                                <p className="leading-5">
                                    When browsing through our jobs, use the filters at the top of the page to enter the criteria you care about, then click "Save This Search" in the top right.
                                </p>
                                <button className="bg-[#47D0E6] uppercase px-4 py-1 mt-4 rounded-full font-semibold">
                                    Start searching
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mt-14">
                    <Footer />
                </div>
            </div>
        </Navbar>
    )
}

export default MyJobsPage